// extracted by mini-css-extract-plugin
export default {"toast":"ToastMessage_toast__ZvNqR","text":"ToastMessage_text__B6aXg","close":"ToastMessage_close__Kw-1X"};